module.exports = __webpack_public_path__ + "img/ArrowButtonNex.83d6a8bc.png";